module.exports = __webpack_public_path__ + "img/38885-013_crop.63a3a2d8.jpg";